import { defineStore } from 'pinia'
import { getShop, getDeliveryDates } from '@/api/api'
import { useShopsStore } from '@/stores/Shops.store'
import { useFileListStore } from '@/stores/FileList.store'
import cloneDeep from 'lodash-es/cloneDeep'

export const useCheckOutStore = defineStore('checkOut', {
  state: () => ({
    orderDetails: {
      instruction: '',
      deliveryAddress: {},
      invoiceAddress: {},
      letter: '',
      deliveryDate: {},
      orderType: 'deliver',
      secure: false,
      quotationNo: '',
      project: {
        id: 0,
        name: ''
      },
      reference: '',
      externalId: '',
      phone: ''
    },
    shop: {},
    dates: [],
    products: [],
    orderErrors: []
  }),
  persist: {
    storage: sessionStorage,
    pick: ['orderDetails']
  },
  getters: {
    deliveryAddressIncludedInFiles() {
      const fileListStore = useFileListStore()
      const inCartFiles = fileListStore.fileList.filter(
        (file) => file.inCart === true
      )

      if (inCartFiles.length === 0) {
        return false
      }

      return inCartFiles.every((file) => {
        const specs = file.productSpecs?.specs
        // User templates hebben specs als object: geen bezorgoptie aanwezig
        if (!Array.isArray(specs) || specs.length === 0) {
          return false
        }
        return specs.some((spec) => spec.optionName === 'Standaard_zending')
      })
    }
  },
  actions: {
    addOrderError(error) {
      if (!this.orderErrors.includes(error)) {
        this.orderErrors.push(error)
      }
    },
    removeOrderError(error) {
      this.orderErrors = this.orderErrors.filter((e) => e !== error)
    },
    updateShop(shop) {
      this.shop = shop
    },
    updateDates(dates) {
      this.dates = dates
    },
    updateOrderDetails(key, value) {
      this.orderDetails[key] = value
    },
    updateProject(proj) {
      this.orderDetails.project = {
        name: proj.name || '',
        id: proj.id || 0
      }
    },
    resetOrderDetails() {
      this.orderDetails = {
        instruction: '',
        deliveryAddress: {},
        invoiceAddress: {},
        letter: '',
        deliveryDate: {},
        orderType: 'deliver',
        secure: false,
        quotationNo: '',
        project: {
          id: 0,
          name: ''
        },
        reference: '',
        externalId: '',
        phone: ''
      }
      this.shop = {}
      this.dates = []
      this.products = []
      this.orderErrors = []
    },
    addProduct(products) {
      products.forEach((product) => {
        const theProduct = cloneDeep(product)

        // User templates hebben specs als object i.p.v. array: ongewijzigd overnemen
        const specs = Array.isArray(product.productSpecs.specs)
          ? product.productSpecs.specs
          : null

        if (specs) theProduct.productSpecs.specs = []

        for (const specToCheck of specs ?? []) {
          if (
            product.productSpecs.specs.find(
              (spec) =>
                spec.optionGroupName === 'toggleOptions' &&
                spec.optionName === 'disabled' &&
                spec.title === specToCheck.title &&
                spec.optionName !== specToCheck.optionName
            )
          ) {
            continue
          }
          theProduct.productSpecs.specs.push(specToCheck)
        }

        const prodIndex = this.products.findIndex(
          (prd) => prd.fileName === product.fileName
        )

        if (prodIndex > -1) {
          this.products.splice(prodIndex, 1, theProduct)
        } else {
          this.products.push(theProduct)
        }
      })
    },
    updateQuantity(key, value) {
      this.products.forEach((file) => {
        if (key.includes(file.fileName)) {
          file.quantity = value
        }
      })
    },
    removeFile(fileId) {
      this.products = this.products.filter((file) => file.uuid !== fileId)
    },
    clearProducts() {
      this.products = []
    },
    async getTheShop(val) {
      const shopsStore = useShopsStore()
      const resp = await getShop(val.deliveryAddress, val.invoiceId, val.secure)

      const shop =
        shopsStore.shopsList.find((shop) => resp.location?.id === shop.id) || {}

      this.updateShop(shop)
    },
    async getTheDates(val) {
      const resp = await getDeliveryDates(val.shopId, val.invoiceId, val.secure)
      this.updateDates(resp)
      return resp
    }
  }
})
